// Modules
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import Pikaday from 'pikaday';
import moment from 'moment';
import _ from 'lodash';

function validateDate(date, format) {
  const formatted = moment(date, format).format(format);
  const rfc = moment(date).toISOString();

  return (moment.isMoment(date) && date.toDate())
    || (moment.isDate(date) && date)
    || (date === formatted && formatted)
    || (date === rfc && rfc)
    || null;
}

export default class Date extends React.Component {
  static propTypes = {
    format: PropTypes.string,
    formatSubmit: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    onBlur: PropTypes.func,
    autoFocus: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    format: 'm/d/yy',
    formatSubmit: 'yyyy-mm-dd'
  };

  constructor(props) {
    super(props);

    this.state = { validatedValue: validateDate(props.value, props.format.toUpperCase()) };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const el = ReactDOM.findDOMNode(this);

    this.picker = new Pikaday({
      field: el,
      format: this.props.format.toUpperCase(),
      onSelect: this.onChange,
      showDaysInNextAndPreviousMonths: true,
      enableSelectionDaysInNextAndPreviousMonths: true,
      defaultDate: this.state.validatedValue,
      keyboardInput: false
    });

    if (this.props.autoFocus) this.picker.open();
  }

  componentWillReceiveProps(nextProps) {
    const { value, format } = nextProps;
    const validatedValue = validateDate(value, format.toUpperCase());

    if (validatedValue) {
      const date = moment(validatedValue).startOf('day').toDate();
      this.picker._d = date;
      this.picker.gotoDate(this.picker._d);
    }

    this.setState({ validatedValue });
  }

  componentWillUnmount() {
    this.picker.destroy();
  }

  onChange(value) {
    const data = value.target ? value.target.value : value;
    const validated = data === '' ? null : data;

    this.props.onChange(validated);
  }

  render() {
    const { value, className, format, formatSubmit } = this.props;
    const { validatedValue } = this.state;
    const passedProps = _.omit(this.props, ['value', 'className', 'format', 'onBlur', 'formatSubmit', 'rightAlignPicker', 'onChange']);
    const classes = classNames(className, 'form-control');

    // The value the user sees
    const displayValue = validatedValue ? moment(validatedValue).format(format.toUpperCase()) : value;
    // The value the datepicker uses to store what the user selected. This is separate from the value which will
    // be submitted on form submit, which is stored by redux-form in the app store. This prevents oddities where
    // only last two digits of year are displayed to user and, without dataValue, datepicker gets confused about century
    const dataValue = validatedValue ? moment(validatedValue).format(formatSubmit.toUpperCase()) : undefined;

    return (
      <input {...passedProps} onChange={this.onChange} autoComplete="off" value={displayValue} className={classes} data-value={dataValue} />
    );
  }
}
